import { css } from 'lit-element';
// TODO not sure of the best way to deal with icon fonts yet.. this doesn't feel like it
// basically have to load this in index.html and also declare this stuff stuff here it seems
export class IconStyles {
    static get styles() {
        return css`
            .material-icons-outlined,
            .material-icons {
                font-weight: normal;
                font-style: normal;
                font-size: 24px;
                line-height: 1;
                letter-spacing: normal;
                text-transform: none;
                display: inline-block;
                white-space: nowrap;
                word-wrap: normal;
                direction: ltr;
                font-feature-settings: 'liga';
                -webkit-font-feature-settings: 'liga';
                -webkit-font-smoothing: antialiased;
                user-select: none;
            }

            .material-icons {
                font-family: 'Material Icons';
            }

            .material-icons-outlined {
                font-family: 'Material Icons Outlined';
            }

            /* Rules for sizing the icon. */
            .material-icons.md-18 {
                font-size: 18px;
            }
            .material-icons.md-24 {
                font-size: 24px;
            }
            .material-icons.md-36 {
                font-size: 36px;
            }
            .material-icons.md-48 {
                font-size: 48px;
            }

            /* Rules for using icons as black on a light background. */
            .material-icons.dark {
                color: rgba(0, 0, 0, 0.54);
            }
            .material-icons.dark.inactive {
                color: rgba(0, 0, 0, 0.26);
            }

            /* Rules for using icons as white on a dark background. */
            .material-icons.light {
                color: rgba(255, 255, 255, 1);
            }
            .material-icons.light.inactive {
                color: rgba(255, 255, 255, 0.3);
            }
        `;
    }
}
